import { createAsyncAction } from "../utils/actionCreators";

export const types = {
  CARREGAR_DOCUMENTOS: "@@dominios/DOCUMENTOS",
  CARREGAR_ETAPAS: "@@dominios/ETAPAS",
  CARREGAR_ATIVIDADES: "@@dominios/ATIVIDADES",
  CARREGAR_ANALISTAS: "@@dominios/ANALISTAS",
  CARREGAR_PRODUTOS: "@@dominios/PRODUTOS",
  CARREGAR_LOCALIDADES: "@@dominios/LOCALIDADE",
  CARREGAR_CARTORIOS: "@@dominios/CARTORIO",
  CARREGAR_TEMPLATES: "@@dominios/TEMPLATES",
  CARREGAR_MOTIVOS_CANCELAMENTO: "@@dominios/CARREGAR_MOTIVOS_CANCELAMENTO",
};

export const actions = {
  documentos: createAsyncAction(types.CARREGAR_DOCUMENTOS),
  etapas: createAsyncAction(types.CARREGAR_ETAPAS),
  atividades: createAsyncAction(types.CARREGAR_ATIVIDADES),
  analistas: createAsyncAction(types.CARREGAR_ANALISTAS),
  produtos: createAsyncAction(types.CARREGAR_PRODUTOS),
  localidades: createAsyncAction(types.CARREGAR_LOCALIDADES),
  cartorio: createAsyncAction(types.CARREGAR_CARTORIOS),
  templates: createAsyncAction(types.CARREGAR_TEMPLATES),
  motivos_cancelamento: createAsyncAction(types.CARREGAR_MOTIVOS_CANCELAMENTO),
};
